<p-dialog modal="true" styleClass="atlas-dialog-l" position="top" [closable]="false" [(visible)]="isReviewing" *ngIf="eventSubmission">
  <ng-template pTemplate="header">
    <h4>
      {{ eventSubmission.EventName }}
    </h4>
  </ng-template>
  <form #crudForm="ngForm" class="atlas-form" [wl-busy-overlay]="loadingEventSubmission" [busyCenter]="true">
    <div>
      <label for="event-name">{{ 'events.submissions.submission-list.review-modal.event-name' | translate | ucfirst }}</label>
      <input type="text" name="event-name" id="event-name" [(ngModel)]="eventSubmission.EventName" />
    </div>
    <div>
      <label for="event-type">{{ 'events.submissions.submission-list.review-modal.event-type' | translate | ucfirst }}</label>
      <p-select
        id="event-type"
        styleClass="w-100"
        name="event-type"
        [options]="eventTypes"
        [dataKey]="value"
        placeholder="{{ 'events.submissions.submission-list.review-modal.select-event-type' | translate | ucfirst }}"
        [(ngModel)]="eventSubmission.EventType"
        ngDefaultControl
      ></p-select>
    </div>
    <div>
      <div class="mct-flex mct-row mct-gap-10">
        <div>
          <label for="start-date">{{ 'events.submissions.submission-list.review-modal.start-date' | translate | ucfirst }}</label>
          <wl-date-selector
            type="date"
            name="start-date"
            id="start-date"
            [(ngModel)]="eventSubmission.EventDate"
            ngDefaultControl
          ></wl-date-selector>
        </div>
        <div>
          <label for="start-time">{{ 'events.submissions.submission-list.review-modal.start-time' | translate | ucfirst }}</label>
          <wl-time-selector
            inputCssClass="form-control"
            name="startTime"
            [(ngModel)]="eventSubmission.EventTime"
            ngDefaultControl
          ></wl-time-selector>
        </div>
      </div>
    </div>
    <div>
      <div class="mct-flex mct-row mct-gap-10">
        <div>
          <label for="end-date">{{ 'events.submissions.submission-list.review-modal.end-date' | translate | ucfirst }}</label>
          <wl-date-selector
            type="date"
            name="end-date"
            id="end-date"
            [(ngModel)]="eventSubmission.EventEndDate"
            ngDefaultControl
          ></wl-date-selector>
        </div>
        <div>
          <label for="end-time">{{ 'events.submissions.submission-list.review-modal.end-time' | translate | ucfirst }}</label>
          <wl-time-selector
            inputCssClass="form-control"
            name="endTime"
            [(ngModel)]="eventSubmission.EndTime"
            ngDefaultControl
          ></wl-time-selector>
        </div>
      </div>
    </div>
    <div>
      <label for="event-email-address">{{
        'events.submissions.submission-list.review-modal.event-email-address' | translate | ucfirst
      }}</label>
      <input type="text" name="event-email-address" id="event-email-address" [(ngModel)]="eventSubmission.Email" />
    </div>
    <div>
      <label for="address-1">{{ 'events.submissions.submission-list.review-modal.physical-address' | translate | ucfirst }}</label>
      <input type="text" name="address-1" id="address-1" [(ngModel)]="eventSubmission.Address1" />
      <input class="mt-10" type="text" name="address-2" id="address-2" [(ngModel)]="eventSubmission.Address2" />
    </div>
    <div>
      <div class="mct-flex mct-row mct-gap-10">
        <div class="mct-flex-1-1-auto">
          <label for="city">{{ 'events.submissions.submission-list.review-modal.city' | translate | ucfirst }}</label>
          <input type="text" name="city" id="city" [(ngModel)]="eventSubmission.City" />
        </div>
        <div style="max-width: 80px">
          <label for="state">{{ 'events.submissions.submission-list.review-modal.state' | translate | ucfirst }}</label>
          <wl-state-selector-modern name="state" [(ngModel)]="eventSubmission.State" ngDefaultControl></wl-state-selector-modern>
        </div>
        <div style="max-width: 100px">
          <label for="zip">{{ 'events.submissions.submission-list.review-modal.zip' | translate | ucfirst }}</label>
          <input type="text" name="zip" id="zip" [(ngModel)]="eventSubmission.Zip" />
        </div>
      </div>
    </div>
    <div style="max-width: 100%" *ngIf="eventSubmission.Descr != null && showHTMLEditor">
      <label for="wysiwyg">{{ 'events.submissions.submission-list.review-modal.wysiwyg' | translate | ucfirst }}</label>
      <wl-wysiwyg-editor name="descr" [(ngModel)]="eventSubmission.Descr" [compact]="true"></wl-wysiwyg-editor>
    </div>
    <div style="max-width: 100%">
      <label for="location">{{ 'events.submissions.submission-list.review-modal.location' | translate | ucfirst }}</label>
      <textarea class="mw-100 w-100" name="location" id="location" [(ngModel)]="eventSubmission.Location"></textarea>
    </div>
    <div>
      <label for="submitter-name">{{ 'events.submissions.submission-list.review-modal.submitter-name' | translate | ucfirst }}</label>
      <input type="text" name="submitter-name" id="submitter-name" [(ngModel)]="eventSubmission.YourName" />
    </div>
    <div>
      <label for="submitter-phone">{{ 'events.submissions.submission-list.review-modal.submitter-phone' | translate | ucfirst }}</label>
      <input type="text" name="submitter-phone" id="submitter-phone" [(ngModel)]="eventSubmission.YourPhone" />
    </div>
    <div>
      <label for="submitter-email">{{ 'events.submissions.submission-list.review-modal.submitter-email' | translate | ucfirst }}</label>
      <input type="text" name="submitter-email" id="submitter-email" [(ngModel)]="eventSubmission.YourEmail" />
    </div>
  </form>
  <ng-template pTemplate="footer">
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-danger pull-left"
      [disabled]="isSaving || loadingEventSubmission"
      (click)="reject(eventSubmission)"
    >
      {{ 'events.submissions.submission-list.review-modal.reject' | translate | uppercase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-secondary mr-10"
      [disabled]="isSaving || loadingEventSubmission"
      (click)="close()"
    >
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button
      pButton
      type="button"
      class="atlas-btn atlas-btn-primary"
      [disabled]="!crudForm.valid || isSaving || loadingEventSubmission"
      (click)="save(eventSubmission)"
    >
      <wl-busy [show]="isSaving"></wl-busy>
      <span [hidden]="isSaving">{{ 'events.submissions.submission-list.review-modal.save' | translate | uppercase }}</span>
    </button>
  </ng-template>
</p-dialog>
